import {
  Menu,
  MenuItem,
  MenuItemText,
  SideNavigationMenuItem,
  SideNavigationMenuList,
} from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import { ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationOpenAtom } from '@/atoms/navigation';
import { useIsTouchDevice } from '@/hooks/useIsTouchDevice';
import { NavigationItem } from '@/types/navigation';
import { isSideNavPageActive, isSideNavSectionActive } from './SideNavLinks.utils';

export const SideNavLinks = ({ navItems }: { navItems: NavigationItem[] }) => {
  const location = useLocation();
  const { pathname } = location;

  const [selectedSubmenu, setSelectedSubmenu] = useState<string | null>(null);
  const setIsNavOpen = useSetAtom(navigationOpenAtom);

  const isTouch = useIsTouchDevice();

  const handleMenuItemClick = (menuItemId: string, hasSubNav: boolean) => {
    if (isTouch) {
      if (hasSubNav) {
        const newSelectedSubmenu = !selectedSubmenu ? menuItemId : null;
        setSelectedSubmenu(newSelectedSubmenu);
      } else {
        setIsNavOpen(false);
      }
    }
  };

  // The navigation for a submenu is handled in the componentProps of the MenuItem
  const handleSubmenuItemClick = () => {
    if (isTouch) {
      // Just close the nav on mobile and clear the selected submenu
      setIsNavOpen(false);
      setSelectedSubmenu(null);
    }
  };

  return (
    <SideNavigationMenuList>
      {navItems.map(({ id, icon, path, label, subNav, onClick, target }) => {
        const hasSubNav = !!subNav?.length;

        return (
          <SideNavigationMenuItem
            key={id}
            menuItemId={id}
            icon={icon}
            isSelected={isSideNavSectionActive(pathname, path ?? '')}
            // @ts-ignore: this component thinks it doesn't take null, but the thing we pass has to be null to make it work.
            selectedSubmenu={selectedSubmenu}
            component={Link as unknown as ReactNode}
            componentProps={{
              to: isTouch && hasSubNav ? null : path,
              target: target || '_self',
              onClick: () => {
                if (onClick) onClick();
                else handleMenuItemClick(id, hasSubNav);
              },
            }}
            isSubmenuOpen={selectedSubmenu === id}
            subMenu={
              hasSubNav && (
                <Menu variant="subnavigation">
                  {subNav.map(({ id: subNavId, label, route, target, onClick }) => (
                    <li key={subNavId}>
                      <MenuItem
                        component={Link}
                        componentProps={{
                          to: route,
                          target: target || '_self',
                        }}
                        isActive={isSideNavPageActive(location, route)}
                        variant="subnavigation"
                        size={isTouch ? 'touch' : 'small'}
                        opacity="secondary"
                        onClick={onClick || handleSubmenuItemClick}
                      >
                        {typeof label === 'string' ? <MenuItemText isTouch={isTouch}>{label}</MenuItemText> : label}
                      </MenuItem>
                    </li>
                  ))}
                </Menu>
              )
            }
          >
            {label}
          </SideNavigationMenuItem>
        );
      })}
    </SideNavigationMenuList>
  );
};
